export default "__VITE_ASSET__gIEtGA3$__"